import { useMutation, useQuery } from '@tanstack/react-query';
import type { ExportPerimeter, ExportRequest, ExportResult } from './types';

// Appels interceptés par MSW (mocks.ts) — aucun appel réel.

export function usePerimeterSearch(query: string) {
  const q = query.trim();
  return useQuery<ExportPerimeter[]>({
    queryKey: ['urban-map', 'nouveau-panel-selection', 'perimeters', q],
    enabled: q.length >= 2,
    staleTime: 60_000,
    queryFn: async () => {
      const res = await fetch(`/api/urban-map/nouveau-panel-selection/perimeters?q=${encodeURIComponent(q)}`);
      if (!res.ok) throw new Error('Recherche de périmètre indisponible.');
      return (await res.json()) as ExportPerimeter[];
    },
  });
}

export function useExportData() {
  return useMutation<ExportResult, Error, ExportRequest>({
    mutationFn: async (request) => {
      const res = await fetch('/api/urban-map/nouveau-panel-selection/export-data', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
      });
      if (!res.ok) throw new Error("L'export n'a pas pu être lancé.");
      return (await res.json()) as ExportResult;
    },
  });
}
